import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { useApplicationPageAggregatedData, emptyObject } from "./aggregatedData";
import { useApplication } from "./application";
export function useFeatureFlags() {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(aggregatedData) {
        var _aggregatedData$inclu;
        return (_aggregatedData$inclu = aggregatedData.included.find(function (item) {
          return item.type === 'feature_flags';
        })) === null || _aggregatedData$inclu === void 0 ? void 0 : _aggregatedData$inclu.attributes;
      }
    }),
    data = _useApplicationPageAg.data;
  return {
    featureFlags: data || emptyObject
  };
}
export function useIsNewLayoutEnabled() {
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useFeatureFlags = useFeatureFlags(),
    featureFlags = _useFeatureFlags.featureFlags;
  return Boolean(featureFlags['application_apr_layout'] && application.newView);
}